import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getBookingEnginePath } from 'utils/routeUtils';
import { Row, Col } from 'reactstrap';
import { numberOfGuestsShape } from 'utils/shapes';

const CheckInCheckOut = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & > div {
    flex: 0 1 auto;
    width: 100%;
  }

  .arrow {
    display: none;
  }

  @media screen and (min-width: ${props =>
      props.theme.breakpoints.extraSmall}) {
    justify-content: space-between;

    & > div {
      width: auto;
    }

    .arrow {
      display: block;
    }
  }
`;

function CheckInDetails({
  startDate,
  endDate,
  className,
  numberOfGuests,
  hideNumberOfGuests = false
}) {
  const startDateMoment = moment(startDate);
  const endDateMoment = moment(endDate);

  const startFormatted = startDateMoment.format('MMM DD, YYYY');
  const endFormatted = endDateMoment.format('MMM DD, YYYY');
  const days = endDateMoment.diff(startDateMoment, 'days');

  return (
    <div className={className}>
      <CheckInCheckOut>
        <div>
          <h5>Check In</h5>
          <h4>{startFormatted}</h4>
        </div>
        <div className="arrow">
          <FontAwesomeIcon icon="long-arrow-alt-right" role="presentation" />
        </div>
        <div>
          <h5>Check Out</h5>
          <h4>{endFormatted}</h4>
        </div>
      </CheckInCheckOut>
      <Row>
        <Col xs="12" sm="8">
          <div>
            <span>
              {days + 1} Days, {days} {days > 1 ? 'Nights' : 'Night'}
            </span>
            <Link
              to={{
                pathname: getBookingEnginePath(),
                state: { transitionDirection: 'back' }
              }}
            >
              Edit Dates
            </Link>
          </div>
        </Col>
        <Col xs="12" sm="4" style={{ textAlign: 'right' }}>
          <div className="numGuests">
            {!hideNumberOfGuests && (
              <span>
                {numberOfGuests.value}{' '}
                {numberOfGuests.value > 1 ? 'Guests' : 'Guest'}
              </span>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

CheckInDetails.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  numberOfGuests: numberOfGuestsShape,
  hideNumberOfGuests: PropTypes.bool
};

const StyledDetails = styled(CheckInDetails)`
  margin-bottom: 0.5em;

  h5 {
    color: ${props => props.theme.h5.color};
    font-size: ${props => props.theme.h5.fontSize};
    text-transform: ${props => props.theme.textUpperCase};
    margin-bottom: 0;
  }

  h4 {
    font-size: ${props => props.theme.h4.fontSize};
    font-weight: ${props => props.theme.fontBold};
  }

  .arrow {
    font-size: ${props => props.theme.arrow.fontSize};
  }

  a {
    margin-left: 0.5em;
  }

  @media screen and (max-width: 880px) {
    .numGuests {
      text-align: left;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
    text-align: left;
    .numGuests {
      text-align: right;
    }
  }
`;

export default StyledDetails;
